// Генерация всех координат гексов для заданного радиуса
import {DEFAULT_GRID_CONFIG} from "../constants/gridConfig";

function generateHexGrid(radius) {
  const hexes = {};

  // Генерируем все координаты в диапазоне [-radius, radius]
  for (let q = -radius; q <= radius; q++) {
    const r1 = Math.max(-radius, -q - radius);
    const r2 = Math.min(radius, -q + radius);

    for (let r = r1; r <= r2; r++) {
      const key = `${q},${r}`;
      hexes[key] = 'sea';
    }
  }

  return hexes;
}

// Создание состояния игры по умолчанию (все гексы - море)
export function createDefaultSharedGameState() {
  const hexes = generateHexGrid(DEFAULT_GRID_CONFIG.radius);

  return {
    gridConfig: DEFAULT_GRID_CONFIG,
    hexes: hexes,
    playerColors: [],
  };
}